// extracted by mini-css-extract-plugin
export default {"contact_page":"Contact_contact_page__f-gSr"};